import { AppThemeContext, AppThemeState } from '@/contexts/app-theme/helpers';
import { useContext } from 'react';

const useAppTheme = () => useContext<AppThemeState>(AppThemeContext);

export default useAppTheme;
